import { Component, ComponentFactoryResolver, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AspSettingsService } from './asp-settings.service';
import { ToastrService } from 'ngx-toastr';
import { AspWebsiteSettingComponent } from '../asp-website-setting/asp-website-setting.component';
import { AspWebsiteSettingService } from '../asp-website-setting/asp-website-setting.service';
import { AspRatecardSettingComponent } from '../asp-ratecard-setting/asp-ratecard-setting.component';
import { AspRatecardSettingService } from '../asp-ratecard-setting/asp-ratecard-setting.service';

@Component({
  selector: 'app-asp-settings',
  templateUrl: './asp-settings.component.html',
  styleUrls: ['./asp-settings.component.scss']
})
export class AspSettingsComponent implements OnInit {
  termsAndConditions: string;

  constructor(
    private aspSettingsService: AspSettingsService,
     private toastr: ToastrService,
     private aspWebsiteSettingService:AspWebsiteSettingService,
     private resolver: ComponentFactoryResolver,
     private aspRatecardSettingService :AspRatecardSettingService
  ) { }

  ngOnInit(): void {
    this.getTerms();
  }
  selectedTab: string = 'jobCard';
  selectedTabs: string = 'terms';
  jobCardTerms: string = '';
  quotationTerms: string = '';
  invoiceTerms: string = '';

  selectTab(tab: string) {
    this.selectedTab = tab;
    console.log('terms',this.jobCardTerms);
    
    console.log('quotationTerms',this.quotationTerms);
    console.log('invoiceTerms',this.invoiceTerms);
  }
  selectTabs(tab: string) {
    this.selectedTabs = tab;
  
    if (tab === 'website') {
      setTimeout(() => this.loadOrderDetails(), 100); // Let Angular render first
    }
    if(tab === 'ratecard')
    {
      setTimeout(() => this.loadOrderDetails1(), 100);
    }
  }
  

  createTermsAndConditions(){
    let garageKey=localStorage.getItem('garageKey');
    let termsAndConditionsType= this.selectedTab;
    if (this.selectedTab === 'jobCard') {
      this.termsAndConditions = this.jobCardTerms;
    } else if (this.selectedTab === 'quotation') {
      this.termsAndConditions = this.quotationTerms;
    } else if (this.selectedTab === 'invoice') {
      this.termsAndConditions = this.invoiceTerms;
    }
    this.aspSettingsService.createTermsAndConditions(garageKey,this.termsAndConditions,termsAndConditionsType).subscribe(
      result => {
            console.log("result",result);
            this.toastr.success(result['message']);
      })
  }  
  getTerms(){ 
    let garageKey=localStorage.getItem('garageKey');
    this.aspSettingsService.getTerms(garageKey).subscribe(
      result => {
        console.log("result",result);
        this.invoiceTerms=result['data'].invoice;
        console.log("this.invoiceTerms",this.invoiceTerms)
        this.quotationTerms=result['data'].quotation;
        this.jobCardTerms=result['data'].jobCard;
      })
  }
    // @ViewChild('myButton') myButton!: ElementRef<HTMLButtonElement>;
    // @ViewChild('dynamicContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
    @ViewChild('dynamicContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
     @ViewChild('dynamicContainer1', { read: ViewContainerRef }) container1!: ViewContainerRef;

    // @ViewChild('bottomSheetTemplate') bottomSheetTemplate!: TemplateRef<any>;
    // @ViewChild('vehicleServiceHistoryContainer', { read: ViewContainerRef }) historyContainer!: ViewContainerRef;
  
    loadOrderDetails(): void {
      if (!this.container) {
        console.warn('ViewContainerRef not available yet');
        return;
      }
    
      this.container.clear();
      const factory = this.resolver.resolveComponentFactory(AspWebsiteSettingComponent);
      const componentRef = this.container.createComponent(factory);
    
      const componentInstance = componentRef.instance as AspWebsiteSettingComponent;
      componentInstance.ngOnInit(); // optional
    }

    loadOrderDetails1(){
      if (!this.container1) {
        console.warn('ViewContainerRef not available yet');
        return;
      }
    
      this.container1.clear();
      const factory = this.resolver.resolveComponentFactory(AspRatecardSettingComponent);
      const componentRef = this.container1.createComponent(factory);
    
      const componentInstance = componentRef.instance as AspRatecardSettingComponent;
      componentInstance.ngOnInit(); 
    }

    }    

